<template>
    <send-list-form
        v-bind="formData"
        @created="onCreated"
        @updated="onUpdated"
    ></send-list-form>
</template>

<script>
  import Form from "../../../send-list/send-list-conversation-form";

  export default {
    components: {
      'send-list-form': Form,
    },

    props: {
      getFormUrl: String,
    },

    data() {
      return {
        formData: {},
      };
    },

    methods: {
      loadForm() {
        axios.get(this.getFormUrl)
          .then(({data: {data: {...formData}}}) => {
            this.formData = formData;
            this.$emit('initialized');
          })
          .catch(({response: {data: {message}}}) => {
            const payload = _.assign({}, message ? {message} : {});
            this.$emit('initialization-error', payload);
          });
      },

      onCreated(payload) {
        this.$emit('created', payload);
      },

      onUpdated(payload) {
        this.$emit('updated', payload);
      },
    },

    mounted() {
      this.loadForm();
    },
  }
</script>

